import { TBins } from './CalculateBlend'
import { DropdownOption } from '../../components/ui/Dropdown/Dropdown'

export enum TIME_GRANULARITY {
  DAILY = 'daily',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export interface ITrendChartsFilters {
  wheat_codes?: string[]
  bins?: string[]
  blend_types?: string[]
  blend_type?: DropdownOption
  date_range: TDateRange
  time_granularity?: TIME_GRANULARITY
}

export type TDateRange = {
  from: string
  to: string
}

export type TParametersComparisonData = {
  wheat_code: string
  value: number | null
  std_dev: number | null
}

export type TParametersTrendData = {
  wheat_code: string
  series_data: {
    date: string
    value: number
    std_dev: number
  }[]
}

export type TConsistencyTrendData = {
  wheat_code: string
  consistent_count: number
  borderline_count: number
  inconsistent_count: number
  total_count: number
  consistent_percentage: number
  borderline_percentage: number
  inconsistent_percentage: number
  score: number
}

type BinDistributionProp = {
  count: number
  percentage: number
  color_hex_code: string
}

export type TBinDistributionData = {
  wheat_code: string
  bin_distribution: {
    additionalProp1: BinDistributionProp
    additionalProp2: BinDistributionProp
    additionalProp3: BinDistributionProp
  }
  total_samples_in_wheat_code: number
  spread_score: number
}

export type TCostTrendData = {
  date: string
  blend_type: string
  cost: number
  currency: unknown // Clarify if needed
}

export type TCompositionData = {
  date: string
  bins: Partial<TBins>[]
  parameters: {
    name: string
    avg: number
    unit: string
  }[]
  cost: number
  currency: unknown // Clarify if needed
}

// Left for legacy reasons
export type TParametersComparisonResponse = Record<
  string,
  TParametersComparisonData[]
>

export type TTrendChartResponseType = TParametersComparisonResponse

export type TChartRow = {
  code: string
  value: number
  std: number
}

export type TWheatColorById = Record<number, string>
export type TWheatColorByCode = Record<string, string>

export type TAttributeUnits = Record<string, string>

export type TDistributionData = {
  bin_id: number
  bin_name: string
  segments: {
    wheat_code: string
    volume_percentage: number
    unusual_storage_samples: {
      timestamp: string
      description: string
    }[]
  }[]
  attributes: {
    name: string
    avg: number
    std: number
  }[]
}

export type ChartKey =
  | 'parameters_comparison'
  | 'parameters_trend'
  | 'consistency_trend'
  | 'spectral_image_comparison'
  | 'bin_distribution'
  | 'cost_trends'
  | 'compositions'
  | 'storage_distribution'
  | (string & {})
